import React from "react";
import { CssBaseline, ThemeProvider } from '@mui/material';
import AppRoutes from "./routes/AppRoutes";
import appTheme from './theme/appTheme';
import GlobalAppStyles from './theme/GlobalAppStyles';

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <GlobalAppStyles />
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
